import React from 'react';
import "../../../styles/principals/login.css";
import axios from "axios";

const Login = () => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const email = formData.get('email');
    const password = formData.get('password');

    console.log(email, password);

    if (email && password) {
      axios.post(`${process.env.REACT_APP_API_URL}/users/login`, {
        email: email,
        password: password
      })
    
      .then(response => {
        console.log(response.data.message);  
        const token = response.data.token; // Asumiendo que el token se devuelve en response.data.token
        localStorage.setItem('authToken', token); // Guardar el token en localStorage
        window.location.href = '/admin-menu';      
      })
      .catch(error => {
        console.error(error);
        // Aquí puedes manejar los errores, como mostrar un mensaje al usuario indicando que las credenciales son incorrectas
      });
    } else {
      console.error('El email y la contraseña son campos obligatorios');
    }
  };

  return (
    <div className="login-container">
      <h1>Tu cuenta NOI</h1>
      <div className="form-container">
        <form className="login-form" onSubmit={handleSubmit}>
          <p className="login-text">BIENVENIDO/A.</p>
          <p className="login-text">Portal de administrador NOI</p>
          <input type="text" name="email" placeholder="Usuario" />
          <input type="password" name="password" placeholder="Contraseña" />
          <button className="home-button" type="submit">CONECTARME</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
